export enum HolidayConditionType {
    Month = 0,
    DayOfWeek = 1,
    LastBeforeDay = 2,
    DayOfWeekInMonth = 3
}